import { render, staticRenderFns } from "./userRoleForm.vue?vue&type=template&id=6805aa82&scoped=true&"
import script from "./userRoleForm.vue?vue&type=script&lang=js&"
export * from "./userRoleForm.vue?vue&type=script&lang=js&"
import style0 from "./userRoleForm.vue?vue&type=style&index=0&id=6805aa82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6805aa82",
  null
  
)

export default component.exports